"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.UserCreateDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var user_preferences_dto_1 = require("./user-preferences.dto");
var UserCreateDto = (function () {
    function UserCreateDto() {
        this.preferences = {
            locale: 'en-US',
            currency: 'USD'
        };
    }
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UserCreateDto.prototype, "isActive");
    __decorate([
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "email");
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(4),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "password");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "name");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "surname");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "company");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['ADMIN', 'EMPLOYEE']),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "type");
    __decorate([
        class_transformer_1.Type(function () { return user_preferences_dto_1.UserPreferencesDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", user_preferences_dto_1.UserPreferencesDto)
    ], UserCreateDto.prototype, "preferences");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UserCreateDto.prototype, "role");
    return UserCreateDto;
}());
exports.UserCreateDto = UserCreateDto;
//# sourceMappingURL=user-create.dto.js.map